import React from "react";
import { Bar } from "react-chartjs-2";

const SectorAllocationChart = ({ data, options = {}, onClick, className = "", isDarkMode, indexAxis = "x" }) => {
  const chartOptions = {
    ...options,
    onClick,
    maintainAspectRatio: false,
    indexAxis: indexAxis, // Support both vertical and horizontal bars
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: isDarkMode ? 'rgba(17, 24, 39, 0.8)' : 'rgba(255, 255, 255, 0.95)',
        titleColor: isDarkMode ? '#fff' : '#111827',
        bodyColor: isDarkMode ? '#fff' : '#111827',
        borderColor: isDarkMode ? 'rgba(75, 85, 99, 0.3)' : 'rgba(209, 213, 219, 0.5)',
        borderWidth: 1,
        padding: 10,
        callbacks: {
          label: (context) => {
            const value = context.raw;
            const dataset = context.dataset;
            const total = dataset.data.reduce((acc, curr) => acc + curr, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return [
              `Amount: $${value?.toLocaleString(undefined, { maximumFractionDigits: 0 })}`,
              `${percentage}% of total assets`
            ];
          }
        }
      }
    },
    scales: {
      x: {
        grid: {
          color: isDarkMode ? 'rgba(75, 85, 99, 0.1)' : 'rgba(209, 213, 219, 0.25)',
          borderColor: isDarkMode ? 'rgba(75, 85, 99, 0.2)' : 'rgba(209, 213, 219, 0.5)',
        },
        ticks: {
          color: isDarkMode ? '#fff' : '#4B5563',
          font: { size: 10 },
          maxRotation: 45,
          minRotation: 45,
          // For vertical bars, show sector names on X-axis
          callback: indexAxis === "x" ? (value, index) => data.labels[index] : (value) => `$${value.toLocaleString(undefined, { maximumFractionDigits: 0 })}`
        },
      },
      y: {
        grid: {
          color: isDarkMode ? 'rgba(75, 85, 99, 0.1)' : 'rgba(209, 213, 219, 0.25)',
          borderColor: isDarkMode ? 'rgba(75, 85, 99, 0.2)' : 'rgba(209, 213, 219, 0.5)',
        },
        ticks: {
          color: isDarkMode ? '#fff' : '#4B5563',
          font: { size: 10 },
          // For vertical bars, show dollar amounts on Y-axis
          callback: indexAxis === "x" ? (value) => `$${value.toLocaleString(undefined, { maximumFractionDigits: 0 })}` : undefined
        },
      },
    },
  };

  return (
    <div className="w-full h-full">
      <Bar data={data} options={chartOptions} />
    </div>
  );
};

export default SectorAllocationChart;
